import { motion } from "framer-motion";
import { TEAM } from "@/components/laneeka/data";

const initials = (name) =>
  name.replace(/^Engr\.\s*/, "").split(" ").filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase();

export default function TeamPage() {
  return (
    <main data-testid="team-page" className="pt-[108px]">
      <section className="bg-slate-950 border-b border-slate-800 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-xs font-semibold uppercase tracking-widest text-blue-400 mb-3">About</p>
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-white">Our Team</h1>
          <p className="mt-3 text-slate-400 max-w-2xl">
            The people behind Laneeka International — sales, technical services, accounts and operations,
            working as one to keep your production lines moving.
          </p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {TEAM.map((m, i) => (
            <motion.div
              key={`${m.name}-${i}`}
              data-testid={`team-member-${i}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.45, delay: (i % 4) * 0.05 }}
              className="bg-[#faf6f1] border border-slate-200 rounded-xl p-8 text-center hover:shadow-md transition-shadow"
            >
              <img
                src={m.photo}
                alt={m.name}
                loading="lazy"
                className="w-24 h-24 mx-auto rounded-full object-cover ring-4 ring-white shadow"
              />
              <h3 className="mt-5 font-bold text-slate-900">{m.name}</h3>
              <p className="mt-1 text-sm text-slate-500">{m.role}</p>
            </motion.div>
          ))}
        </div>
      </section>
    </main>
  );
}
